import React from 'react';
import { ServiceFactory } from '../../servicelib';
import { useHistory } from 'react-router-dom';
import { Marquee } from '../marquee';
import { CarouselStoreService } from '../../sxmservicelayer/carousel-store/carousel.store.service';
import { CarouselTileService } from '../../sxmservicelayer/carousel-tile/carousel-tile.service';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import './CategoryTile.scss';
import { focusManager } from '@accedo/vdkweb-navigation';

const CategoryTile = ({
  isFocused,
  clicked,
  data,
  category,
  navId,
  tileClick,
}) => {
  const timer = React.useRef<any>(null);
  const history = useHistory();
  const carouselStoreService = ServiceFactory.getInstance(
    CarouselStoreService,
  ) as CarouselStoreService;

  const carouselTileService = ServiceFactory.getInstance(
    CarouselTileService,
  ) as CarouselTileService;
  const callbackFunction = () => {
    focusManager.changeFocus(navId);
    if (data.categoryGuid) {
      carouselStoreService.selectSubCategory(data);
    }
    if (data.primaryNeriticLink) {
      carouselTileService.onClickNeriticLinkAction(data);
    } else {
      // Use push so that users can go back
      history.push(`/category-listing/${category}/${data.key}/channels`);
      window.scroll(0, 0);
    }
  };
  useUpdateEffect(() => {
    callbackFunction();
  }, [clicked]);

  const handleMouseOver = () => {
    timer.current = setTimeout(() => focusManager.changeFocus(navId), 200);
  };
  const handleMouseOut = () => {
    clearTimeout(timer.current);
  };
  return (
    data && (
      <div
        className={`category-card ${isFocused ? 'category-card-focused' : ''}`}
        style={{
          backgroundImage: `url(${data.bgImageUrl}?width=256&height=256&preserveAspect=true)`,
        }}
        onClick={() => tileClick()}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        <img className="category-card-logo" src={data.fgImageUrl} alt="" />
        <div className="category-card-info">
          <Marquee
            text={data.line1 !== '' ? data.line1 : data.name}
            isFocused={isFocused}
            lightBackground={false}
          />
        </div>
      </div>
    )
  );
};

export default CategoryTile;
